/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class CursorManager {
    public static readonly SERVICE_NAME = 'CursorStateResponse';

    private static subscribers = {};

    private static subscribeCount = 0;

    private static mCursorState = false;

    public static onChange(state: boolean) {
        const keys = Object.keys(CursorManager.subscribers);
        this.mCursorState = state;

        keys.forEach((key) => {
            const notify = CursorManager.subscribers[key];
            if (typeof notify === 'function') notify(state);
        });
    }

    public static subscribe(callback: Function): number {
        const ref = CursorManager.subscribeCount;
        CursorManager.subscribers[ref] = callback;
        CursorManager.subscribeCount += 1;
        return ref;
    }

    public static unsubscribe(ref: number) {
        delete CursorManager.subscribers[ref];
    }

    public static isCursorAppeared() {
        return this.mCursorState;
    }
}
